import axios from "axios";
import { API_URL } from "../index";

// FE-84: Services.js'ten taşındı (6 uç). Metotlar Services nesnesinde birleşir; this.X çağrıları çalışır.
const servisGenelbakis = {
  AdminOverviewSales(token, dateFrom, dateTo) {
    return axios({
      method: "post",
      url: `${API_URL}flow/admin-overview-sales`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { date_from: dateFrom || 0, date_to: dateTo || 0 },
    });
  },
  AdminOverviewOps(token, dateFrom, dateTo) {
    return axios({
      method: "post",
      url: `${API_URL}flow/admin-overview-ops`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { date_from: dateFrom || 0, date_to: dateTo || 0 },
    });
  },
  AdminOverviewCustomers(token, dateFrom, dateTo) {
    return axios({
      method: "post",
      url: `${API_URL}flow/admin-overview-customers`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { date_from: dateFrom || 0, date_to: dateTo || 0 },
    });
  },
  UpdateUserStatus(token, userID, currentStatus, options = {}) {
    const protectActiveCustomer = Boolean(options?.protectActiveCustomer);
    const allowActiveCustomerOverride = Boolean(options?.allowActiveCustomerOverride);

    const nextStatus = String(currentStatus ?? "").trim();
    const shouldProtect = protectActiveCustomer && !allowActiveCustomerOverride && nextStatus !== "1";

    const doUpdate = () =>
      axios({
        method: "post",
        url: `${API_URL}flow/update-user-profile`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: {
          userID,
          currentStatus,
        },
      });

    if (!shouldProtect) return doUpdate();

    const resolveSkip = (reason) =>
      Promise.resolve({
        data: {
          status: true,
          result: { skipped: true, reason },
        },
      });

    const checkAndUpdate = (user) => {
      const type = String(user?.type ?? "").toLowerCase();
      const status = String(user?.currentStatus ?? "").trim();
      if (type === "customer" && status === "1") {
        return resolveSkip("ACTIVE_CUSTOMER_LOCK");
      }
      return doUpdate();
    };

    if (options?.userType || options?.userCurrentStatus != null) {
      return checkAndUpdate({ type: options.userType, currentStatus: options.userCurrentStatus });
    }

    return axios({
      method: "post",
      url: `${API_URL}flow/get-users`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userID: userID,
      },
    })
      .then((res) => {
        if (!res?.data?.status) return resolveSkip("USER_STATUS_LOOKUP_FAILED");
        const user = Array.isArray(res?.data?.result) ? res.data.result[0] : res?.data?.result;
        if (!user) return resolveSkip("USER_STATUS_LOOKUP_FAILED");
        return checkAndUpdate(user);
      })
      .catch(() => resolveSkip("USER_STATUS_LOOKUP_FAILED"));
  },

  // Üyelik silme (müşteri) — Profil > Şifre ve Güvenlik.
  GetAccountDeletionStatus(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-account-deletion-status`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    });
  },

  UpdateFileStatus(token, fileID, status) {
    return axios({
      method: "post",
      url: `${API_URL}flow/company-document-change-status`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        fileID,
        status
      }
    });
  },
};

export default servisGenelbakis;
